import { Helmet } from "react-helmet-async";

export default function Seo({
    title = "India Reels — India's Own Reels Platform",
    description = "Create, share and discover short videos by Indian creators. Made in India, for India.",
    path = "/",
}) {
    const url = `https://india-reels.com${path}`;
    const full = title.includes("India Reels") ? title : `${title} · India Reels`;
    return (
        <Helmet>
            <title>{full}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={full} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta name="twitter:title" content={full} />
            <meta name="twitter:description" content={description} />
        </Helmet>
    );
}
